import { Phone, Mail, MapPin, Youtube, Twitter, Instagram, Linkedin, Facebook } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const CONTACT_PHONE = process.env.REACT_APP_CONTACT_PHONE;

const API_URL = window.location.href.includes("localhost")
  ? process.env.REACT_APP_API_URL_LOCAL
  : process.env.REACT_APP_API_URL_PROD;


const Footer = () => {

  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

  // Fetch properties
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch(`${API_URL}api/get-property-names`);
        const data = await res.json();
        if (data.success && data.data) {
          setProjects(data.data);
        }
      } catch (error) {
        console.error("Failed to fetch property names:", error);
      }
    };
    fetchProjects();
  }, []);

const icons = [
  {
    href: "https://www.youtube.com/@Solapur_property_",
    icon: <Youtube className="h-5 w-5" />,
    bg: "from-red-500 to-red-600",
    hoverBg: "from-red-600 to-red-700",
  },
  {
    href: "https://www.instagram.com/solapur_property_?igsh=M2lta2RrZzNtZ20%3D&utm_source=qr",
    icon: <Instagram className="h-5 w-5" />,
    bg: "from-pink-500 to-purple-500",
    hoverBg: "from-pink-600 to-purple-600",
  },
  {
    href: "https://www.facebook.com/share/1A4LqVxuh8/?mibextid=wwXIfr",
    icon: <Facebook className="h-5 w-5" />,          // Make sure you import Facebook icon
    bg: "from-blue-500 to-blue-600",
    hoverBg: "from-blue-600 to-blue-700",
  },
];

  const quickLinks = [
    { "name": "About Us", link: "/about-us" },
    { "name": "Our Projects", link: "/explore-properties" },
    { "name": "Contact Us", link: "/contact-us" },
    // { "name": "Investment Plans" },
    // { "name": "Customer Support" },
    // { "name": "Site Visit" },
    // { "name": "EMI Calculator" },
    // { "name": "Careers" },
  ]


  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h3 className="font-display-bold text-2xl text-luxury mb-6">
              Premium Properties
            </h3>
            <p className="text-white/80 leading-relaxed mb-6">
              Creating exceptional living experiences through premium real estate
              developments that combine luxury, comfort, and investment value.
            </p>
            <div className="flex space-x-4">
              {icons.map((item, idx) => (
                <a
                  key={idx}
                  href="#"
                  onClick={() => window.open(item.href, "_blank")}
                  className={`w-12 h-12 rounded-full flex items-center justify-center bg-gradient-to-br ${item.bg} text-white shadow-lg hover:bg-gradient-to-br ${item.hoverBg} transition-all duration-300 transform hover:scale-110`}
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg text-luxury mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks && quickLinks.map((link, index) => (
                <li key={index} onClick={() => navigate(`${link?.link}`)}>
                  <a href="#" className="text-white/80 hover:text-luxury transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Projects */}
         <div>
            <h4 className="font-display text-lg text-luxury mb-6">Our Projects</h4>
            <ul className="space-y-3">
              {projects.length > 0 ? (
                projects.map((p) => (
                  <li key={p._id}>
                    <a
                      href="#"
                      onClick={() => navigate(`/properties/${slugify(p.name)}-${p._id}`)}
                      className="text-white/80 hover:text-luxury transition-colors"
                    >
                      {p.name}
                    </a>
                  </li>
                ))
              ) : (
                <li className="text-white/60 italic">Loading projects...</li>
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-display text-lg text-luxury mb-6">Contact Info</h4>
            <div className="space-y-4">
              {/* <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-luxury mt-1 flex-shrink-0" />
                <div className="text-white/80">
                  <div>Premium Tower, 15th Floor</div>
                  <div>Business District, Central City</div>
                  <div>PIN: 110001</div>
                </div>
              </div> */}

              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-luxury flex-shrink-0" />
                <div className="text-white/80">
                  <div><b>CEO: Shiva Chilveri</b></div>
                
                  <div>+91 {CONTACT_PHONE}</div>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-luxury flex-shrink-0" />
                <div className="text-white/80">
                  <div>support@skylinepropertiess.com</div>
                  <div>sales@skylinepropertiess.com</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            <div className="text-white/60 text-sm">
              © 2024 Premium Properties. All rights reserved.
            </div>

            <div className="flex flex-wrap gap-6 text-sm">
              <a href="#" className="text-white/60 hover:text-luxury transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-white/60 hover:text-luxury transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-white/60 hover:text-luxury transition-colors">
                RERA Compliance
              </a>
              <a href="#" className="text-white/60 hover:text-luxury transition-colors">
                Disclaimer
              </a>
            </div>
          </div>

          <div className="text-center mt-6 pt-6 border-t border-white/10">
            <p className="text-white/60 text-xs max-w-4xl mx-auto">
              RERA Registration Numbers: Project Skyline - RERA/P/SG/2024/001, Project Vista - RERA/P/SG/2024/002,
              Project Gardens - RERA/P/SG/2024/003. All projects are developed in compliance with Real Estate
              (Regulation and Development) Act, 2016. Please check RERA website for complete project details.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;